import messages from './messages'


const getCollaborationLabel = (collaboration: CollaborationsModule.Collaboration) => {
  return collaboration ? messages[collaboration] : null
}

export default getCollaborationLabel
